import styled from 'styled-components'

import { Text, Layout } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { numberFormatter } from 'core/utils/number'

import { getShipmentPercentageText } from '../presenters/shipmentsMetadataPresenter'

type MetadataBoxProps = {
  active?: boolean
}

const MetadataBox = styled(Layout.Box)<MetadataBoxProps>`
  --m-box-background-color: ${props =>
    toCSSValue(props.active ? 'color-background-tertiary' : 'color-background-primary')};

  cursor: ${props => (props.onClick ? 'pointer' : 'default')};

  &:hover {
    --m-box-background-color: ${props =>
      toCSSValue(props.active ? 'color-background-highlight' : 'color-background-tertiary')};
  }
`

export function ShipmentsMetadataItem({
  active,
  title,
  value,
  totalShipments,
  onClick,
}: {
  active?: boolean
  title: string
  value: number
  totalShipments: number
  onClick: () => void
}) {
  return (
    <MetadataBox
      active={active}
      borderWidth="border-thin"
      borderColor={active ? 'color-neutral-40' : 'color-border'}
      padding="spacing-4"
      onClick={onClick}
    >
      <Layout.Stack gap="spacing-1">
        <Layout.Stack gap="none">
          <Text variant="body-sm" color="color-text-secondary">
            {title}
          </Text>
          <Text
            variant="heading-md-bold"
            color={active ? 'color-text-primary' : 'color-text-secondary'}
          >
            {numberFormatter(value)}
          </Text>
        </Layout.Stack>
        <Text variant="body-sm" color="color-text-tertiary">
          {getShipmentPercentageText(value, totalShipments)}
        </Text>
      </Layout.Stack>
    </MetadataBox>
  )
}
